import { ReferralInfo as IReferralInfo } from '../../../interfaces';
import { FC, useState } from 'react';
import { Card } from '../../../utilities/components';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { ReferralWithdrawalModal } from './referralWithdrawalModal/referralWithdrawalModal.index';

interface Props {
    info?: IReferralInfo;
    loading: boolean;
    onWithdrawalComplete: () => void;
}

export const ReferralInfo: FC<Props> = (props) => {
    const [withdrawalModalOpen, setWithdrawalModalOpen] = useState<boolean>(false)

    return (
        <div className={'flex w-full gap-6 max-lg:flex-wrap max-lg:gap-4 whitespace-nowrap mt-6 max-lg:mt-4'}>
            <ReferralWithdrawalModal open={withdrawalModalOpen} setOpen={setWithdrawalModalOpen} balance={props.info?.balance} onComplete={props.onWithdrawalComplete} />
            <Card size={'small'} className={'flex-1 max-lg:min-w-40'} loading={props.loading}>
                <div className={'flex w-full flex-col gap-[10px] max-lg:gap-2 flex-1'}>
                    <h5 className={'font-bold text-base max-lg:text-sm'}>
                        مجموع پاداش دریافتی
                    </h5>
                    <div className={'flex items-center gap-3 max-lg:gap-2'}>
                            <span
                                className={'text-primary-100 font-medium text-xl max-lg:text-[18px]'}>{props?.info?.totalBalance.toLocaleString()}</span>
                        <span className={'text-black-100 font-medium text-base max-lg:text-sm'}>تومان</span>
                    </div>
                </div>
            </Card>
            <Card size={'small'} className={'flex-1 max-lg:min-w-40'} loading={props.loading}>
                <div className={'flex w-full flex-col gap-[10px] max-lg:gap-2 flex-1'}>
                    <h5 className={'font-bold text-base max-lg:text-sm'}>
                        معاملات دوستان
                    </h5>
                    <div className={'flex items-center gap-3 max-lg:gap-2'}>
                            <span
                                className={'text-primary-100 font-medium text-xl max-lg:text-[18px]'}>{props?.info?.actionCount.toLocaleString()}</span>
                        <span className={'text-black-100 font-medium text-base max-lg:text-sm'}>تراکنش</span>
                    </div>
                </div>
            </Card>
            <Card size={'small'} className={'flex-1 max-lg:min-w-40'} loading={props.loading}>
                <div className={'flex w-full flex-col gap-[10px] max-lg:gap-2 flex-1'}>
                    <h5 className={'font-bold text-base max-lg:text-sm'}>
                        دوستان دعوت شده
                    </h5>
                    <div className={'flex items-center gap-3 max-lg:gap-2'}>
                            <span
                                className={'text-primary-100 font-medium text-xl max-lg:text-[18px]'}>{props?.info?.userCount.toLocaleString()}</span>
                        <span className={'text-black-100 font-medium text-base max-lg:text-sm'}>نفر</span>
                    </div>
                </div>
            </Card>
            <Card size={'small'} className={'flex-1 max-lg:min-w-40'} loading={props.loading}>
                <div className={'flex w-full flex-col gap-[10px] max-lg:gap-2 flex-1'}>
                    <h5 className={'font-bold text-base max-lg:text-sm'}>
                        دوستان احراز شده
                    </h5>
                    <div className={'flex items-center gap-3 max-lg:gap-2'}>
                            <span
                                className={'text-primary-100 font-medium text-xl max-lg:text-[18px]'}>{props?.info?.authenticatedUsersCount.toLocaleString()}</span>
                        <span className={'text-black-100 font-medium text-base max-lg:text-sm'}>نفر</span>
                    </div>
                </div>
            </Card>
            <Card size={'small'} className={'flex-1 max-lg:min-w-40'} loading={props.loading}>
                <div className={'flex w-full flex-col gap-[10px] max-lg:gap-2 flex-1'}>
                    <h5 className={'flex justify-between items-center font-bold text-base max-lg:text-sm'}>
                        موجودی فعلی
                        <FaArrowLeftLong className={"clickable"} onClick={() => setWithdrawalModalOpen(true)} />
                    </h5>
                    <div className={'flex items-center gap-3 max-lg:gap-2'}>
                            <span
                                className={'text-primary-100 font-medium text-xl max-lg:text-[18px]'}>{props?.info?.balance.toLocaleString()}</span>
                        <span className={'text-black-100 font-medium text-base max-lg:text-sm'}>تومان</span>
                    </div>
                </div>
            </Card>
        </div>
    );
};